import { withTranslation } from 'react-i18next';
import { Component } from 'react';
import { AI_TOOLS } from '../../configs';
import { showPlatform } from '../../PromptManager/keys';
import ShowAllItemsModal from './ShowAllItemsModal';

class Platforms extends Component {
    constructor(props) {
        super(props);

        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);

        const prompts = this.props.prompts?.flatMap((item) => item.platforms) || [];
        const uniquePrompts = [...new Set(prompts)];

        this.onClickShowAll = this.onClickShowAll.bind(this);
        this.state = {
            showLess: uniquePrompts.length > 4,
            data: uniquePrompts,
            isOpenModal: false,
        };
    }

    onClickShowAll = () => {
        this.setState({ showLess: false });
    };

    onOpenModal() {
        this.setState({ isOpenModal: true });
    }

    onCloseModal() {
        this.setState({ isOpenModal: false });
    }

    render() {
        const { t } = this.props;
        const { showLess } = this.state;

        const firstOnes = this.state.data.slice(0, 4);
        const data = showLess ? firstOnes : this.state.data;

        return (
            <>
                <div className={'ai-tracking-prompts-cell'}>
                    {data?.map((state) => (
                        <div key={state} title={AI_TOOLS[state]} className="ai-tracking-platform-2">
                            {showPlatform(state)}
                        </div>
                    ))}
                    {showLess && (
                        <div className="ai-tracking-platform-show-more" onClick={this.onOpenModal}>
                            + {this.state.data.length - firstOnes.length}
                        </div>
                    )}
                </div>
                {this.state.isOpenModal && (
                    <ShowAllItemsModal
                        isOpen={this.state.isOpenModal}
                        onClose={this.onCloseModal}
                        data={this.state.data?.map((item) => ({
                            name: AI_TOOLS[item],
                            view: (
                                <div>
                                    {showPlatform(item)} {AI_TOOLS[item]}
                                </div>
                            ),
                        }))}
                        placeholder={t('ai_tracking.global.search_platforms')}
                    />
                )}
            </>
        );
    }
}

export default withTranslation()(Platforms);
